import ApiService from './ApiService';

export default class NewsApi extends ApiService {
    constructor() {
        super('topics');
    }

    getAllTopic(payload) {
        return this.get('', payload);
    }

    getTopicDetail(code) {
        return this.get(code);
    }

    createTopic(payload) {
        return this.post('', payload, { headers: { 'Content-Type': 'multipart/form-data' } });
    }

    updateTopic(payload) {
        const { code, data } = payload;
        return this.put(code, data, { headers: { 'Content-Type': 'multipart/form-data' } });
    }

    updateTopicStatus(payload) {
        const { code, status } = payload;
        return this.put(`status/${code}`, { status });
    }

    updateApproveTopic(payload) {
        const { code, data } = payload;
        return this.put(`approve/${code}`, data);
    }

    deleteTopic(code) {
        return this.delete(code);
    }
}
